module.exports = __webpack_public_path__ + "media/images/logo-dc5de41aae4c8a9dc7b263702a2caba5.svg";